module.exports = __webpack_public_path__ + "img/mdSign.099373b4.png";